import { createSignal } from '@verclam/pulsar';

/** `true` while the panel that edits a dossier's sheet is open. */
const editSubjectSidebarSignal = createSignal<boolean>(false);

export const openEditSubjectSidebar = (): void => {
	editSubjectSidebarSignal.value = true;
};

export const closeEditSubjectSidebar = (): void => {
	editSubjectSidebarSignal.value = false;
};

export default editSubjectSidebarSignal;
